import React from 'react';
import AuthPageReader from '../AuthPageReader.jsx';

const RetailSignInReader = (props) => <AuthPageReader {...props} domainType="RETAIL" pageKey="signIn" />;

export default RetailSignInReader;
